/**
 * Локальне (в localStorage браузера) збереження прочитаних розділів ГОСТЯ — окремо для кожного твору. Залогінені зберігають прочитане на сервері,
 *     в гостя акаунта немає, тож без цього всі розділи завжди виглядали б непрочитаними;
 * Модуль навмисно без імпортів з api.ts/auth.ts.
 */
const READ_PREFIX = 'yomukoma:guest-read:';
const MAX_READ_PER_NOVEL = 20000;

function loadArray(key: string): unknown[] {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveArray(key: string, arr: unknown[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(arr));
  } catch {
    /* сховище недоступне або переповнене — діятиме до перезавантаження сторінки */
  }
}

const readKey = (pluginId: string, novelPath: string) => `${READ_PREFIX}${pluginId}:${novelPath}`;

export function getGuestReadSet(pluginId: string, novelPath: string): Set<string> {
  return new Set(loadArray(readKey(pluginId, novelPath)).filter((v): v is string => typeof v === 'string'));
}

export function markGuestRead(pluginId: string, novelPath: string, chapterPath: string): void {
  const key = readKey(pluginId, novelPath);
  const arr = loadArray(key);
  if (arr.includes(chapterPath)) return;
  arr.push(chapterPath);
  saveArray(key, arr.length > MAX_READ_PER_NOVEL ? arr.slice(-MAX_READ_PER_NOVEL) : arr);
}
